export default "__VITE_ASSET__07f6c8b1__"